import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export const ArrowIcon = (props: IconProps): ReactElement => (
  <IconWrapper {...props}>
    <path d="M8.00016 7.41L12.5802 12L8.00016 16.59L9.41016 18L15.4102 12L9.41016 6L8.00016 7.41Z" />
  </IconWrapper>
);
